const isFn = (fn) => typeof fn === 'function';

// noinspection JSUnusedGlobalSymbols
export default isFn;
